export default __webpack_public_path__ + "static/media/facebook.8ddd8a8c.webp";